<p-dialog
  [(visible)]="displayModal"
  modal="modal"
  [draggable]="false"
  responsive="true"
  appendTo="body"
  [closeOnEscape]="false"
>
  <p-header>
    <div class="modal-logo-close">
      <i class="logo-icon t-icon t-icon-logo"></i
      ><a
        class="close-x"
        (click)="deviceDetail ? (displayModal = false) : goToCart()"
        id="cta-default-702"
        ><i class="fa fa-times"></i
      ></a>
    </div>
    <h3>
      {{ deviceDetail ? aemContent?.deviceErrorTitle : aemConfigurableData?.deviceErrorModalTitle }}
    </h3>
  </p-header>
  <div class="modal-body">
    <div class="row">
      <div class="col-12" *ngIf="deviceDetail">
        <p class="m-t-md">{{ aemContent?.deviceErrorSubtext }}</p>
        <p class="bold m-t-lg">{{ aemContent?.deviceErrorCart }}</p>
        <p class="m-t-sm">
          {{ cartList?.device?.offerName }} - {{ cartList?.device?.color }} -
          {{ cartList?.device?.memory }} {{ cartList?.device?.memoryUOM }}
        </p>
        <p class="m-t-sm">{{ cartList?.plan?.description }}</p>
        <p class="bold m-t-xl">{{ aemContent?.deviceErrorSelection }}</p>
        <p class="m-t-sm">{{ deviceDetail?.familyName }} - {{ deviceDetail?.defaultSelection }}</p>
      </div>
      <div class="col-12" *ngIf="!deviceDetail">
        <p class="m-t-md">{{ aemConfigurableData?.deviceErrorModalSubtext }}</p>
      </div>
    </div>
  </div>
  <p-footer>
    <div class="row">
      <div class="col-12 buttons-container button-spacing" *ngIf="deviceDetail">
        <div class="button-box">
          <button class="btn btn-secondary" (click)="addToCart()" id="btn-default-199">
            {{ aemContent?.deviceErrorAddButton }}
          </button>
        </div>
        <div class="button-box">
          <button class="btn btn-primary" (click)="newSelection()" id="btn-default-200">
            {{ aemContent?.deviceErrorSelectionButton }}
          </button>
        </div>
      </div>
      <div class="col-12 buttons-container button-spacing" *ngIf="!deviceDetail">
        <div class="button-box">
          <button class="btn btn-primary" (click)="goToCart()" id="btn-default-201">
            {{ aemConfigurableData?.deviceErrorModalPrimaryCTA }}
          </button>
        </div>
      </div>
    </div>
  </p-footer>
</p-dialog>
